import React, { Component } from "react";
import { Link, Navigate } from "react-router-dom";
import { get_hdr_dtl_action } from "../actions/common_action/fillList_action";
import { responseError, role_id, toastError } from "../utils/constants";
import { connect } from "react-redux";
import { withRouter } from "../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class MobileHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user_id: sessionStorage.getItem("user_id"),
            role_id: sessionStorage.getItem("role_id"),
            headerNames: [],
            headerData: [],
            selectedEvent: null,
            guest: sessionStorage.getItem("AwardsUserLoginData") == null,
            activeTab: '',
            application_form_id: '', roundName: '', totalJuryCount: '', totalJuryReviewedCount: ''
        };
        this.logout = this.logout.bind(this);
        this.handleEventChange = this.handleEventChange.bind(this);
    }

    componentDidMount() {
        const { guest } = this.state;
        this.setState({ application_form_id: this.props.location.state != null && this.props.location.state.application_form_id })
        if (guest) {
            this.props.navigate('/logout')
        } else {
            this.getHdrDtl();
        }
    }
    getHdrDtl() {
        const { user_id, role_id } = this.state;
        this.props.get_hdr_dtl_action(user_id, role_id)
            .then((data) => {
                if (data.error !== 1) {
                    this.setState({
                        headerData: data.data[0],
                        headerNames: data.data[1],
                        roundName: data.data[1]?.[0]?.round_name, totalJuryCount: data.data[1]?.[0]?.total_count, totalJuryReviewedCount: data.data[1]?.[0]?.total_reviewed_count
                    }, () => {
                        // If no award event is stored, set the nearest one
                        const storedAwardEventId = sessionStorage.getItem('award_event_id') != null ? sessionStorage.getItem('award_event_id') : false;

                        if (!storedAwardEventId) {
                            this.setNearestEvent();
                            setTimeout(() => {
                                this.getHdrDtl()
                            }, 10);
                        } else {
                            // Otherwise, ensure the stored event is selected
                            const selectedEvent = this.state.headerData.find(event =>
                                event.award_event_id.toString() === storedAwardEventId
                            );
                            this.setState({ selectedEvent });
                        }
                    });
                } else {
                    responseError(data);
                }
            })
            .catch((e) => console.log(e));
    }

    setNearestEvent() {
        const { headerData } = this.state;
        if (headerData.length === 0) return;

        const today = new Date();

        const nearestEvent = headerData.reduce((prev, curr) => {
            const currFromDate = new Date(curr.award_event_from_date);
            const currToDate = new Date(curr.award_event_to_date);
            const prevFromDate = new Date(prev.award_event_from_date);
            const prevToDate = new Date(prev.award_event_to_date);

            // Calculate the smallest distance from 'today' to the current and previous events' ranges
            const currClosestDate = Math.min(
                Math.abs(currFromDate - today),
                Math.abs(currToDate - today)
            );
            const prevClosestDate = Math.min(
                Math.abs(prevFromDate - today),
                Math.abs(prevToDate - today)
            );

            return currClosestDate < prevClosestDate ? curr : prev;
        });
        sessionStorage.setItem('award_event_id', nearestEvent.award_event_id);
        this.setState({ selectedEvent: nearestEvent });
    }

    getBackgroundColor(statusId) {
        switch (statusId) {
            case 2:
                return '#F1C841'; // Yellow
            case 3:
                return 'red'; // Red
            case 4:
                return 'green'; // Green
            default:
                return 'transparent'; // No color
        }
    }
    async navigateApplicationForm(award_event_profile_id, application_form_id) {
        this.setState({ application_form_id: application_form_id })
        await this.props.navigate('/applicationForm', {
            state: { award_event_profile_id, application_form_id }
        });
        window.location.reload();
    }
    handleEventChange(eventId) {
        const selectedEvent = this.state.headerData.find(
            (event) => event.award_event_id === eventId
        );
        this.setState({ selectedEvent });
    }

    logout() {
        sessionStorage.clear();
        this.props.navigate('/login')
    }
    toggleAwards = (award_event_id) => {
        const currentAwardEventId = sessionStorage.getItem('award_event_id');
        if (currentAwardEventId === award_event_id.toString()) {
            sessionStorage.removeItem('award_event_id');
            this.setState({ selectedEvent: null });
        } else {
            sessionStorage.setItem('award_event_id', award_event_id);
            const selectedEvent = this.state.headerData.find(event =>
                event.award_event_id === award_event_id
            );
            this.setState({ selectedEvent }, () => this.props.navigate('/adminDashboard'));
        }
    };

    render() {
        const { role_id, guest, selectedEvent, headerData, user_id, headerNames, roundName, totalJuryCount, totalJuryReviewedCount } = this.state;
        const userLoginData = JSON.parse(sessionStorage.getItem("AwardsUserLoginData"));
        const name = userLoginData ? userLoginData.user_name : '';
        const EmailId = userLoginData ? userLoginData.email_address : '';
        const mobileNo = userLoginData ? userLoginData.contact_no : '';
        const initial = name ? name[0] : '';

        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 768, // Mobile
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        };

        return (
            <>
                <div className="website">
                    <marquee
                        style={{ fontSize: "14px", color: "#000", fontWeight: "500" }}
                        behavior="scroll"
                        direction="left"
                        scrollamount="5"
                        onMouseOver={(e) => e.target.stop()}
                        onMouseOut={(e) => e.target.start()}
                    >
                        <b>Disclaimer and Ownership: </b> All content, including text, graphics, images, and other materials on this website and associated online application systems/accounts, is the exclusive property of India ITME Society or is used under appropriate license. Unauthorized copying, reproduction, distribution, publication, display, modification, creation of derivative works, transmission, or any other form of exploitation of this content is strictly prohibited without prior written consent from the copyright owner. Any violation of these terms will result in immediate legal action and enforcement of intellectual property rights.
                    </marquee>
                    <header className="main_header_area position-absolute w-100">
                        <div className="header_menu " id="header_menu">

                            <nav className="navbar navbar-expand-lg navbar-light bg-light p-0">
                                <div className="container-fluid header-padding">
                                    <div className="d-flex">

                                        <a className="navbar-brand p-0 m-0" >
                                            <Link to='/'>
                                                <img src="../static/images/logo.png" alt="Logo" className="logo-img"
                                                    style={{ width: 140, margin: "6px 0px" }} />
                                            </Link>
                                        </a>
                                        <button
                                            className="navbar-toggler border-0"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#navbarResponsive"
                                            aria-controls="navbarResponsive"
                                            aria-expanded="false"
                                            aria-label="Toggle navigation"
                                            style={{ outline: 'none' }}
                                        >
                                            <span className="navbar-toggler-icon" />
                                        </button>
                                    </div>
                                    {/* Navigation Menu */}
                                    <div className="collapse navbar-collapse" id="navbarResponsive">
                                        <ul
                                            className="navbar-nav me-auto mb-2 mb-lg-0 "
                                        >
                                            {user_id && (
                                                <li className="drop-down profile_li">
                                                    <ul style={{ paddingTop: "0px" }}>
                                                        <li className="nav-item name_li mobile-dpsce"><a className="" style={{ padding: '' }}>
                                                            <p className="nameClass pl-2">
                                                                {name}<br />
                                                                {EmailId}<br />
                                                                {mobileNo}{mobileNo != '' && mobileNo != null && <br />}
                                                            </p></a></li>
                                                    </ul>
                                                </li>
                                            )}
                                            <li className="menu-item drop-down mobile-dpsce2">
                                                <div className="dropdown-header ">
                                                    <p className="mb-0 pb-0 head-drop">{selectedEvent ? selectedEvent.award_event_name : "Select Event"} {role_id == 1 ? <i className="fa fa-chevron-down dropdown-icon ml-1" /> : <></>}</p>
                                                    <span>
                                                        {selectedEvent
                                                            ? new Date(selectedEvent.award_event_from_date).toLocaleDateString("en-US", {
                                                                day: "2-digit",
                                                                month: "long",
                                                                year: "numeric",
                                                            })
                                                            : ""}
                                                    </span>

                                                </div>
                                            </li>
                                            {role_id == 1 ? (
                                                <>
                                                    <li className="nav-item p-n3 nav-link"><div className="header-menu mpbile-desp3"><Link to="/adminDashboard"><span className={this.props.location.pathname === '/adminDashboard' ? "active" : ''}>Dashboard</span></Link></div></li>
                                                    <li className="nav-item p-n3 nav-link"><div className="header-menu"><Link to="/adminApplicationList"><span className={this.props.location.pathname === '/adminApplicationList' ? "active" : ''}>Application</span></Link></div></li>
                                                    <li className="nav-item p-n3 nav-link"> <div className=" header-menu"><Link to="/applicationMatrix"><span className={this.props.location.pathname === '/applicationMatrix' ? "active" : ''}>Matrix</span></Link></div></li>

                                                    <li className="nav-item p-n3 nav-link">
                                                        <div className=" header-menu"><Link to="/juryBriefing"><span className={this.props.location.pathname === '/juryBriefing' ? "active" : ''}>Jury Briefing</span></Link></div>
                                                    </li>
                                                    <li className="nav-item menu-font dropdown mpb-5">
                                                        <a
                                                            className="nav-link dropdown-toggle px-2 my-4 py-0 text-dark mobile-6"
                                                            role="button"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            Master <i class="fa fa-angle-down" aria-hidden="true"></i>
                                                        </a>
                                                        <ul className="dropdown-menu bg-lightgrey top-nav p-0 rounded">
                                                            <li className="nav-item p-n3"><Link to="/role" className="nav-link">Role</Link></li>
                                                            <li className="nav-item p-n3"><Link to="/user" className="nav-link">User</Link></li>
                                                            <li className="nav-item p-n3"><Link to="/AdminCircular" className="nav-link">Circular</Link></li>
                                                            <li className="nav-item p-n3"><Link to="/awardEvent" className="nav-link">Award Event</Link></li>
                                                            <li className="nav-item p-n3"><Link to="/juryProfile" className="nav-link">Jury Profile</Link></li>
                                                            <li className="nav-item p-n3"><Link to="/proformaList" className="nav-link">Proforma List</Link></li>
                                                            <li className="nav-item p-n3"><Link to="/taxInvoiceList" className="nav-link">TaxInvoice List</Link></li>
                                                            <li className="nav-item p-n3"><Link to="/receiptList" className="nav-link">Receipt</Link></li>
                                                            <li className="nav-item p-n3"><Link to="/applicationQuery" className="nav-link">Query</Link></li>
                                                            <li className="nav-item p-n3"><Link to="/reportList" className="nav-link">Reports</Link></li>
                                                        </ul>
                                                    </li>

                                                </>
                                            ) : role_id == 2 ? (
                                                <>
                                                    <div className="mt-2 header-menu"><Link to="/juryDashboard"><span className={this.props.location.pathname === '/juryDashboard' ? "active" : ''}>Dashboard</span></Link></div>
                                                    <div className="mt-2 header-menu"><Link to="/juryReview">
                                                        <div class={`award-card`} style={{ height: 'auto', padding: '10px', top: '-10px' }}>
                                                            <div class={`award-id ${this.props.location.pathname === "/juryReview" && "active-menu"}`}>{roundName}
                                                                <span class={`award-status submitted`}>{totalJuryReviewedCount}/{totalJuryCount}</span>
                                                            </div>
                                                        </div>
                                                    </Link></div>
                                                </>
                                            ) : role_id == 3 ? (
                                                <>
                                                    <li className="drop-down profile_li">
                                                        <ul className="mob-menu" style={{ paddingTop: "0px" }}>
                                                            <li className="nav-item p-n3 nav-link"><Link to="/juryBriefing"><span className={this.props.location.pathname === '/juryBriefing' ? "active" : ''}>Jury Briefing</span></Link>
                                                            </li>
                                                            <li className="nav-item p-n3"><Link to="/applicationQuery" className="nav-link">Query</Link></li>
                                                            <li className="nav-item p-n3"><Link to="/reportList" className="nav-link">Reports</Link></li>
                                                        </ul>
                                                    </li>
                                                </>
                                            ) : role_id == 4 ? (
                                                <>
                                                    <div className="mt-2 header-menu" >
                                                        <Link to="/applicantDashboard"><div className={this.props.location.pathname === '/applicantDashboard' ? "active" : ''}>Dashboard</div></Link>
                                                    </div>
                                                    <style>
                                                        {`
                                                    .slider-container {
                                                      text-align: center;
                                                      margin: 20px auto;
                                                      padding: 0 10px; /* Add padding for mobile view */
                                                      max-width: 100%;
                                                    }
                                                    .button {
                                                      margin: 5px;
                                                      padding: 10px 15px;
                                                      background-color: #007bff;
                                                      color: white;
                                                      border: none;
                                                      border-radius: 5px;
                                                      cursor: pointer;
                                                      font-size: 16px;
                                                    }
                                                    .button:hover {
                                                      background-color: #0056b3;
                                                    }
                                                    .slick-prev:before, .slick-next:before {
                                                      color: black;
                                                    }
                                                    .slick-dots {
                                                      bottom: -30px; /* Adjust dot position */
                                                    }
                                                    @media (max-width: 768px) {
                                                      .button {
                                                        font-size: 14px;
                                                        padding: 8px 12px;
                                                      }
                                                      .slider-container h2 {
                                                        font-size: 18px;
                                                      }
                                                    }
                                                    `}
                                                    </style>
                                                    {headerNames != '' &&
                                                        <>
                                                            <div
                                                                style={{
                                                                    width: "250px",
                                                                    margin: "0 auto",
                                                                }}
                                                            >
                                                                {headerNames.length > 1 ?
                                                                    <Slider {...settings}>
                                                                        {headerNames.length > 0 && headerNames.map((data, i) => (
                                                                            <>
                                                                                <div class={`award-card ${(data.application_form_id == (this.state.application_form_id || this.props.data)) && "featured"}`} onClick={() => this.navigateApplicationForm(data.award_event_profile_id, data.application_form_id)}>
                                                                                    <div class="award-id">{data.application_no}
                                                                                        <span class={`award-status ${data.status_name == 'Draft' ? "draft" : data.status_name == 'Submitted' ? 'submitted' : data.status_name == 'Rejected' ? 'rejected' : data.status_name == 'Reviewed' ? 'reviewed' : data.status_name == 'Verified' ? 'verified' : 'verified'}`}>{data.status_name}</span>
                                                                                    </div>
                                                                                    <div class="award-title">{data.award_name}</div>
                                                                                </div>
                                                                            </>
                                                                        ))}
                                                                    </Slider>
                                                                    :
                                                                    <>
                                                                        <div className="awards-wrapper">
                                                                            {headerNames.length > 0 && headerNames.map((data, i) => (
                                                                                <>
                                                                                    <div class={`award-card ${(data.application_form_id == (this.state.application_form_id || this.props.data)) && "featured"}`} onClick={() => this.navigateApplicationForm(data.award_event_profile_id, data.application_form_id)}>
                                                                                        <div class="award-id">{data.application_no}
                                                                                            <span class={`award-status ${data.status_name == 'Draft' ? "draft" : data.status_name == 'Submitted' ? 'submitted' : data.status_name == 'Rejected' ? 'rejected' : data.status_name == 'Reviewed' ? 'reviewed' : data.status_name == 'Verified' ? 'verified' : 'verified'}`}>{data.status_name}</span>
                                                                                        </div>
                                                                                        <div class="award-title">{data.award_name}</div>
                                                                                    </div>
                                                                                </>
                                                                            ))}
                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>
                                                        </>
                                                    }

                                                    <li className="drop-down profile_li">
                                                        <ul style={{ paddingTop: "0px" }}>
                                                            <li className="nav-item p-n3 nav-link"> Notification</li>
                                                            <li className="nav-item p-n3"><Link to="/proformaList" className="nav-link">Proforma</Link></li>
                                                            <li className="nav-item p-n3"><Link to="/receiptList" className="nav-link">Receipt</Link></li>
                                                        </ul>
                                                    </li>
                                                    {/* <li>
                                                        {user_id && (
                                                            <li className="drop-down profile_li">
                                                                <ul style={{ paddingTop: "0px" }}>
                                                                    <li className="nav-item name_li">
                                                                        <a className="nav-link"><p className="nameClass">
                                                                            {name}<br />
                                                                            {EmailId}<br />
                                                                            {mobileNo}{mobileNo != '' && mobileNo != null && <br />}
                                                                        </p></a>
                                                                    </li>
                                                                    <li className="nav-item"><Link to="/profile" className="nav-link">My Profile</Link></li>
                                                                    <li className="nav-item"><Link to="/changePassword" className="nav-link">Change Password</Link></li>
                                                                    <li onClick={this.logout} className="nav-item">
                                                                        <a style={{ cursor: "pointer", color: "red" }} className="nav-link">Logout</a>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                        )}
                                                    </li> */}
                                                </>
                                            ) : <></>}

                                            {guest ? (
                                                <nav className="nav-menu d-none d-lg-block">
                                                    <ul>
                                                        <Link to="/login">
                                                            <li className={this.props?.mod?.data == 9 ? "nav-item active" : "nav-item"}>
                                                                <a className="nav-link py-3">Login/Register</a>
                                                            </li>
                                                        </Link>
                                                    </ul>
                                                </nav>
                                            ) : (
                                                <>
                                                    {user_id && (
                                                        <li className="drop-down profile_li last-menu">
                                                            <ul className=".mob-menu" style={{ paddingTop: "0px" }}>
                                                                <li className="nav-item"><Link to="/profile" className="nav-link">My Profile</Link></li>
                                                                <li className="nav-item"><Link to="/changePassword" className="nav-link">Change Password</Link></li>
                                                                <li onClick={this.logout} className="nav-item">
                                                                    <a style={{ cursor: "pointer", color: "red" }} className="nav-link">Logout</a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    )}

                                                    {/* {role_id == 4 && (
                                                        )} */}


                                                </>
                                            )}
                                            {/* <div className={role_id == 4 ? "col-2" : "col-9"}>
                                                <nav className="nav-menu">
                                                    <ul className="menu-list">
                                                        <li className="menu-item drop-down">
                                                            <div className="dropdown-header ">
                                                                <p className="mb-0 pb-0 head-drop">{selectedEvent ? selectedEvent.award_event_name : "Select Event"} {role_id == 1 ? <i className="fa fa-chevron-down dropdown-icon ml-1" /> : <></>}</p>
                                                                <span>
                                                                    {selectedEvent
                                                                        ? new Date(selectedEvent.award_event_from_date).toLocaleDateString("en-US", {
                                                                            day: "2-digit",
                                                                            month: "long",
                                                                            year: "numeric",
                                                                        })
                                                                        : ""}
                                                                </span>

                                                            </div>
                                                            {role_id == 1 ? (
                                                                <ul className="dropdown-list  p-0">
                                                                    {headerData
                                                                        .filter((data) => data.award_event_id !== selectedEvent?.award_event_id)
                                                                        .map((event) => (
                                                                            <li
                                                                                key={event.award_event_id}
                                                                                className="dropdown-item"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => this.toggleAwards(event.award_event_id)}
                                                                            >
                                                                                {event.award_event_name}
                                                                            </li>
                                                                        ))}
                                                                </ul>
                                                            ) : <></>}
                                                        </li>
                                                        {role_id == 1 || role_id == 3 ? (
                                                            <>
                                                                <div className="mt-2 header-menu"><Link to="/adminDashboard"><span className={this.props.location.pathname === '/adminDashboard' ? "active" : ''}>Dashboard</span></Link></div>
                                                                <div className="mt-2 header-menu"><Link to="/adminApplicationList"><span className={this.props.location.pathname === '/adminApplicationList' ? "active" : ''}>Application</span></Link></div>
                                                                <div className="mt-2 header-menu"><Link to="/applicationMatrix"><span className={this.props.location.pathname === '/applicationMatrix' ? "active" : ''}>Matrix</span></Link></div>
                                                                {role_id == 3 ? <></> : <div className="mt-2 header-menu"><Link to="/juryBriefing"><span className={this.props.location.pathname === '/juryBriefing' ? "active" : ''}>Jury Briefing</span></Link></div>}
                                                            </>
                                                        ) : role_id == 2 ? (
                                                            <>
                                                                <div className="mt-2 header-menu"><Link to="/juryDashboard"><span className={this.props.location.pathname === '/juryDashboard' ? "active" : ''}>Dashboard</span></Link></div>
                                                                <div className="mt-2 header-menu"><Link to="/juryReview"><div className="mt-2 header-menu" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <div><span>Round 1</span></div>
                                                                </div></Link></div>
                                                            </>
                                                        ) : role_id == 4 ? (
                                                            <>
                                                                <div className="mt-2 header-menu" >
                                                                    <Link to="/applicantDashboard"><div className={this.props.location.pathname === '/applicantDashboard' ? "active" : ''}>Dashboard</div></Link>
                                                                </div>
                                                            </>
                                                        ) : <></>}
                                                    </ul>
                                                </nav>
                                            </div> */}
                                        </ul>
                                    </div>
                                </div>
                            </nav>

                            {/* </div> */}
                            <div id="search1">
                                <button type="button" className="close">
                                    ×
                                </button>
                                <form>
                                    <input
                                        className="form-control form-control-lg rounded text-white"
                                        placeholder="Search..."
                                    />
                                </form>
                                <button type="button" className="btn">
                                    <i className="fa fa-search text-white" />
                                </button>
                            </div>
                        </div>
                    </header >
                </div >
            </>
        );
    }
}
export default withRouter(
    connect(null, { get_hdr_dtl_action })(MobileHeader)
);
